import React from "react"
import { motion } from "framer-motion"
import { numberOfAnswers, failXTime } from "./Constants"
import SearchSVG from "../../images/search.svg"

export const answerScoreStyle = {
	fontSize: "24px",
	letterSpacing: "1.5px",
	fontWeight: "bold",
}
const AnswerGrid = ({
	query,
	answers,
	roundOver,
	correctAnswers,
	tester,
	giveUp,
}) => (
	<ul
		key="answerList"
		animate={{
			left: 0,
		}}
		initial={{
			left: "-700px",
		}}
		style={{
			display: "inline-block",
			margin: "0",
			padding: 0,
			width: "100%",
		}}>
		{Array.from({ length: tester ? 13 : numberOfAnswers }, (_, val) => (
			<div key={`answerDiv_${val}`} style={{ overflow: "hidden" }}>
				<motion.li
					key={`answer_${val}`}
					id={`answer_${val}`}
					className="answer"
					animate={{
						left: 0,
					}}
					initial={{
						left: "-1000px",
					}}
					exit={{
						left: "1000px",
					}}
					transition={{
						delay: 0.1 * val,
						duration: 0.5,
					}}
					style={{
						position: "relative",
						padding: "5px var(--single)",
						margin: 0,
						display: "flex",
						border: 0,
						height: "25px",
						lineHeight: "25px",
					}}>
					<img
						alt={`Answer #${val}`}
						className="hideOnMobile"
						style={{
							display: "inline-block",
							width: "20px",
							marginRight: "var(--half)",
						}}
						src={SearchSVG}
					/>
					<div className="hideOnMobile" style={{ marginRight: "0.25em" }}>
						{query}
					</div>
					<div
						style={{
							fontWeight: "bold",
							position: "relative",
							marginRight: "var(--single)",
							zIndex: "98",
							whiteSpace: "nowrap",
							fontSize:
								val in answers === true && answers[val].length > 40
									? "13px"
									: "inherit",
						}}>
						<a
							rel="noreferrer"
							target="_blank"
							href={
								"https://www.google.com/search?q=" +
								encodeURIComponent(query + " " + answers[val])
							}>
							{answers[val]}
						</a>
						<motion.div
							key={`reveal_${query}`}
							style={{
								position: "absolute",
								backgroundColor: "var(--blue)",
								height: "100%",
								top: 0,
								right: 0,
							}}
							animate={{
								width: !roundOver && !correctAnswers[val] ? "100%" : 0,
							}}
							initial={{
								width: "100%",
							}}
							transition={{
								type: "spring",
								duration: 0.5,
								bounce: 0,
								delay: roundOver && !giveUp ? failXTime / 1000 + 0.1 * val : 0,
							}}
						/>
					</div>
					<div
						style={{
							...answerScoreStyle,
							flex: 1,
							color: correctAnswers[val] ? "var(--blue)" : "var(--gray)",
							textAlign: "right",
							overflow: "hidden",
							position: "absolute",
							right: "var(--single)",
						}}>
						{((10 - val) * 1000).toLocaleString()}
					</div>
				</motion.li>
			</div>
		))}
	</ul>
)
export default AnswerGrid
